<!-- <ng-template [ngIf]="isComunicandoInstallazioneRouter">
  <app-loading></app-loading>
</ng-template> -->
<!-- <div *ngIf="!readyData">
    <div style="display: flex; align-items: center">
        <div style="flex-grow: 1"></div>
        <div>
            <p-progressSpinner aria-label="loading"/>
        </div>
        <div style="flex-grow: 1"></div>
    </div>
</div> -->
<!-- *ngIf="readyData"-->
<div >

    <div [ngSwitch]="hasSentAnyMaterials">

        <div *ngSwitchCase="true">
            <p-steps [model]="pagineComunicaEsitoInstallazioneRouter" [readonly]="true" [activeIndex]="activeIndex" >  </p-steps>
            <div class="d-flex mt-2">
              <ng-container [ngSwitch]="activeIndex">
                  <ng-container *ngSwitchCase="0">
                    <form [formGroup]="comunicaEsitoInstallazioneRouterForm">
                      <div class="grid formgrid p-fluid">
                        <div class="field mt-2 mb-2 col-6">
                          <label for="dataAppuntamento" >Data appuntamento</label>
                          <p-calendar
                              formControlName="dataAppuntamento"
                              id="dataAppuntamento"
                              [showIcon]="true"
                              dateFormat="dd/mm/yy"
                              placeholder="Indica la data dell'appuntamento"
                              [appendTo]="'body'"
                            ></p-calendar>
                        </div>
                        <div class="field mt-2 mb-2 col-6">
                          <label for="esito" class="font-small text-900 text-blue-900">Esito</label>
                           <span class="p-input-icon-left">
                             <p-selectButton [options]="esiti" formControlName="esito" optionLabel="label" optionValue="value"></p-selectButton>
                           </span>
                       </div>
                       <div *ngIf="!esitoOK" class="field mt-2 mb-2 col-12">
                        <label for="note" class="font-small text-900 text-blue-900">Causa mancata installazione del router:</label>
                        <div class="field-radiobutton">
                          <p-radioButton
                            name="causaFallimento"
                            value="CPE"
                            formControlName="causaFallimento"
                            inputId="causaCPE"
                          ></p-radioButton>
                          <label for="causaFallimento">Problema al CPE</label>
                        </div>
                        <div class="d-flex align-items-center">
                          <div class="field-radiobutton">
                            <p-radioButton
                              name="causaFallimento"
                              value="RETE"
                              formControlName="causaFallimento"
                              inputId="causaRETE"
                            ></p-radioButton>
                            <label for="causaFallimento">Problema di RETE</label>
                          </div>
                          <div *ngIf="comunicaEsitoInstallazioneRouterForm.get('causaFallimento').value === 'RETE'" class="ml-3">
                            <p-dropdown inputId="causaKO"
                              [options]="listeService.opzioniCausaKO"
                              [showClear]="true"
                              placeholder="Indica la causa del KO"
                              formControlName="causaKO"
                              styleClass="w-20rem">
                              <ng-template let-causa pTemplate="item">
                                <div class="flex align-items-center">
                                  <p-tag
                                    [value]="causa.label | uppercase"
                                    [style]="{
                                      'background-color': stiliService.getColoreCategoriaVincoloKO(getPrimoCarattereNumerico(causa.value)),
                                      'color': '#ffffff',
                                      'border-radius': '6px',
                                      'padding': '.25em .25rem',
                                      'font-weight': '700',
                                      'font-size': '11px',
                                      'letter-spacing': '.3px;',
                                      'cursor': 'pointer',
                                    }"
                                    class="mr-1">
                                  </p-tag>
                                </div>
                              </ng-template>
                            </p-dropdown>
                          </div>
                        </div>
                      </div>

                       <div *ngIf="!esitoOK" class="field mt-2 mb-2 col-12">
                         <label for="note" class="font-small text-900 text-blue-900">Note</label>
                         <span class="p-input-icon-left">
                           <i class="pi pi-info-circle"></i>
                           <textarea id="note" rows="5" [autoResize]="true" formControlName="note" pInputTextarea></textarea>
                         </span>
                       </div>
                       </div>
                    </form>
                  </ng-container>
                  <ng-container *ngSwitchCase="1">
                    <form [formGroup]="datiScuolaForm">
                      <div class="grid formgrid p-fluid">
                        <div class="field mt-2 mb-2 col-5">
                          <label for="indirizzo" class="font-medium text-blue-500">Indirizzo</label>
                          <input type="text" formControlName="indirizzo" pInputText>
                        </div>
                          <div class="field mt-2 mb-4 md:col-3 col-4">
                          <label for="comune" class="font-medium text-blue-500">Comune</label>
                          <input type="text" formControlName="comune" placeholder="Comune" pInputText>
                        </div>
                        <div class="field mt-2 mb-2 col-3">
                          <label for="backup" class="font-medium text-blue-500">Backup</label>
                            <span class="p-input-icon-left">
                              <p-selectButton [options]="backup" formControlName="backup" optionLabel="label" optionValue="value"></p-selectButton>
                            </span>
                        </div>
                      </div>
                    </form>
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    <ng-container *ngIf="bypassMagazzino; else materialsFlow">
                      <div class="bypass-magazzino-banner">
                        <div class="bypass-magazzino-banner__icon" aria-hidden="true">
                          <i class="pi pi-box"></i>
                          <span class="bypass-magazzino-banner__icon-badge">
                            <i class="pi pi-ban"></i>
                          </span>
                        </div>
                        <div class="bypass-magazzino-banner__body">
                          <div class="bypass-magazzino-banner__eyebrow">
                            <i class="pi pi-info-circle"></i>
                            Bypass magazzino attivo
                          </div>
                          <h3 class="bypass-magazzino-banner__title">
                            Registrazione materiali non richiesta per le pratiche del
                            <span class="bypass-magazzino-banner__chip">BANDO 1</span>
                          </h3>
                          <p class="bypass-magazzino-banner__text">
                            Il passaggio magazzino non è richiesto.
                            Puoi procedere direttamente alla conferma dell'esito installazione.
                          </p>
                          <ul class="bypass-magazzino-banner__list">
                            <li>
                              <i class="pi pi-check-circle"></i>
                              Nessun invio materiali da verificare
                            </li>
                            <li>
                              <i class="pi pi-check-circle"></i>
                              Nessuna chiusura movimentazioni magazzino
                            </li>
                          </ul>
                          <div class="bypass-magazzino-serial">
                            <label for="serialRouterBypass">
                              <i class="pi pi-tag"></i>
                              Seriale router (NMU 780098)
                            </label>
                            <div class="bypass-magazzino-serial__row">
                              <input
                                id="serialRouterBypass"
                                type="text"
                                pInputText
                                [(ngModel)]="installedSerials['780098']"
                                [placeholder]="pratica.cpeSn ? 'Seriale CPE' : 'Inserisci il seriale del router'"
                                minlength="3"
                              />
                              <small *ngIf="pratica.cpeSn" class="bypass-magazzino-serial__hint">
                                Precompilato dalla pratica; puoi modificarlo se necessario.
                              </small>
                              <small *ngIf="!pratica.cpeSn" class="bypass-magazzino-serial__hint">
                                Nessun seriale presente sulla pratica: puoi inserirlo manualmente (facoltativo).
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #materialsFlow>
                    <ng-container *ngIf="readyData; else materialsLoading">
  <div id="materialsForm">

                          <div>
                              <div style="color: red" *ngIf="hasMissingMaterials">ATTENZIONE: risultano installati livelli di materiali non congruenti con quanto spedito o non sufficienti per un'installazione completa.</div>
                              <div style="color: red" *ngIf="hasMissingSerials">ATTENZIONE: mancano i seriali di uno o più dispositivi.</div>
                              <div style="color: red" *ngIf="!selectedMagazzinoRientro">ATTENZIONE: selezionare un magazzino per gli eventuali rientri di materiali.</div>
                          </div>

                          <div id="holder_materials" style="max-height: 40vh; overflow-y: auto">

                            <div style="display: flex; align-items: center">
                                <div style="flex-grow: 1"></div>
                                    <div style="margin-right: 1em">destinazione rientri</div>
                                    <div>
                                        <p-dropdown name="magazzinoRientro" styleClass="form_select_mid" appendTo="body" [options]='optionsMagazzinoRientro' [(ngModel)]="selectedMagazzinoRientro" placeholder="magazzino" [disabled]="optionsMagazzinoRientro.length == 1"></p-dropdown>
                                    </div>


                                <div style="flex-grow: 1"></div>
                            </div>

                            <p-table styleClass="p-datatable-sm" [value]="regoleRegistrazioneMateriali" dataKey="id"
                                  responsiveLayout="stack">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="id">
                                            <div class="flex justify-content-between align-items-center">
                                                modello
                                            </div>
                                        </th>
                                        <th>
                                            <div class="flex justify-content-between align-items-center">
                                                quantità
                                            </div>
                                        </th>
                                        <th>
                                            <div class="flex justify-content-between align-items-center">
                                                disponibili
                                            </div>
                                        </th>
                                        <th>
                                            <div class="flex justify-content-between align-items-center">
                                                avanzo
                                            </div>
                                        </th>
                                        <th>
                                            <div class="flex justify-content-between align-items-center">
                                                seriale
                                            </div>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rule>
                                        <tr>

                                            <td><span class="text-lowercase">{{ rule.nmu }}: {{ scortaMateriali[rule.nmu]?.modello?.descrizione ?? '—' }}</span></td>
                                            <td><span class="text-lowercase">

                                                <p-inputNumber [(ngModel)]="installedAmounts[rule.nmu]" [showButtons]="true" buttonLayout="horizontal" inputId="horizontal" [step]="1" [min]="0" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" [size]="5" (onInput)="updateMaterialsChecks()">
                                                </p-inputNumber>

                                            </span></td>
                                            <td>
                                                {{ scortaMateriali[rule.nmu]?.balance }}
                                            </td>
                                            <td>
                                                {{ (scortaMateriali[rule.nmu]?.balance ?? 0) - (installedAmounts[rule.nmu] ?? 0) }}
                                            </td>
                                            <td>
                                                <input *ngIf="rule.requiresSerial" type="text" pInputText [(ngModel)]="installedSerials[rule.nmu]" (input)="updateMaterialsChecks()" minlength="3" />
                                            </td>
                                        </tr>
                                    </ng-template>


                            </p-table>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #materialsLoading>
                      <div style="display: flex; align-items: center; justify-content: center; min-height: 12rem">
                        <p-progressSpinner aria-label="Caricamento dati magazzino"></p-progressSpinner>
                      </div>
                    </ng-template>
                    </ng-template>

                  </ng-container>
                  <ng-container *ngSwitchCase="3">

                      <div style="margin-top: 1em; margin-bottom: 1em">

                        <div *ngIf="!bypassMagazzino" style="text-align: center">NOTA: la conferma chiuderà TUTTE le movimentazioni aperte verso la scuola selezionata.</div>
                        <div *ngIf="bypassMagazzino" class="bypass-magazzino-note">
                          <i class="pi pi-box"></i>
                          <span>Per questa pratica il magazzino non viene coinvolto.</span>
                        </div>

                      </div>

                  </ng-container>
              </ng-container>
            </div>
            <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

            <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">

               <p-button icon="pi pi-arrow-left" class="p-button-text mr-2" (click)="activeIndex = activeIndex - 1" [disabled]="activeIndex === 0 "></p-button>
               <p-button icon="pi pi-arrow-right" class="p-button-text mr-1" (click)="changePage()" [disabled]="checkNextStep()"></p-button>

                <!-- button KO isComunicandoInstallazioneRouter || !comunicaEsitoInstallazioneRouterForm.valid ||-->
                <p-button *ngIf="!esitoOK && activeIndex ===0"  icon="pi pi-check" label="{{labelConferma}}"
                  class="p-button-text ml-100" styleClass="p-button-success" severity="{{severityConferma}}" (click)="conferma(true)"
               [disabled]=" (!this.esitoOK && !this.comunicaEsitoInstallazioneRouterForm.get('causaFallimento').value ) ||
               (comunicaEsitoInstallazioneRouterForm.get('causaFallimento').value === 'RETE' && !this.comunicaEsitoInstallazioneRouterForm.get('causaKO').value )"
                ></p-button>

                <!-- button OK -->
                <p-button *ngIf="activeIndex === 3" icon="pi pi-check" label="Conferma esito"
               class="p-button-text ml-100" styleClass="p-button-success" severity="success" (click)="conferma(true)" [disabled]="isConfermaOkDisabled()"
                ></p-button>

<!-- old version w two buttons merged               <p-button *ngIf="(!esitoOK && activeIndex ===0 ) || (activeIndex === 3)"  icon="pi pi-check" label="{{labelConferma}}"
               class="p-button-text ml-100" styleClass="p-button-success" severity="{{severityConferma}}" (click)="conferma(true)"
               [disabled]="isComunicandoInstallazioneRouter || !comunicaEsitoInstallazioneRouterForm.valid || (!this.esitoOK && !this.comunicaEsitoInstallazioneRouterForm.get('causaFallimento').value ) ||
               (comunicaEsitoInstallazioneRouterForm.get('causaFallimento').value === 'RETE' && !this.comunicaEsitoInstallazioneRouterForm.get('causaKO').value ) || (hasMissingSerials || hasMissingMaterials) || (!fullInstallationFormConfirmed) || !selectedMagazzinoRientro"></p-button>-->


               <!-- <p-button *ngIf="activeIndex === pagineComunicaEsitoInstallazioneRouter.length -1" icon="pi pi-check" label=""
                class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isComunicandoInstallazioneRouter"></p-button> -->
            </div>

        </div>
        <div *ngSwitchCase="false">
            ATTENZIONE: per compilare l'installazione è necessario eseguire prima l'invio dei materiali necessari.
        </div>

    </div>
</div>

<p-toast />
<p-confirmDialog /> 